<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <HeaderSmall :pageTitle="trans[lang].title" />

    <section class="section">
      <div class="container">
        <ProjectsList
          v-if="hasProjects"
          :itemsData="listProjects"
          :totalItems="totalProjects"
        />
        <Skeleton v-if="isLoading" />
        <b-message type="is-info" v-if="!hasProjects"
          >Sorry, no Projects at the moment.
        </b-message>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Skeleton from "@/components/Skeleton.vue";
import HeaderSmall from "@/components/HeaderSmall.vue";
import ProjectsList from "@/components/ProjectsList.vue";
export default {
  name: "projects",
  components: {
    HeaderSmall,
    ProjectsList,
    Skeleton
  },
  data() {
    return {
      isLoading: false,
      hasProjects: true,
      newsData:{},
      startID: 0,
      totalProjects: null,
      listProjects: null,
      currentPage: null,
      trans:{
        en: {
          title: "Projects",
          description: "Slobozia Christian Baptist Church Projects to support children education and poor families.",        
          },
        ru: {
          title: "Проекты",
          description: "Проекты помощь бедным семьям и детям",
         },
      },
      hasMeta: {
        title: "Projects",
        description: "Slobozia Christian Baptist Church Projects to support children education and poor families.",
      }
    };
  },
  methods: {
    loadData() {
      // if()
      let startFrom = 0;
      if(this.$route.params.page){
        startFrom = (this.$route.params.page - 1) * 5;
      }
      let getFrom = this.lang+"-projects?published=true&_sort=id:desc&_start="+startFrom+"&_limit=5";
      this.isLoading = true;
      this.axios
        .get(getFrom)
        .then(response => {
          this.isLoading = false;
          if (response.data.length > 0) {
            this.listProjects = response.data;
            console.log(this.listProjects);
          } else {
            console.log("Error getting data");
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.hasProjects = false;
          console.log(error);
        });
      //.finally(() => (this.loading = false));
    },
    countData() {
      let getFrom = this.lang+"-projects/count";
      this.axios
        .get(getFrom)
        .then(response => {
          if (response.data > 0) {
            this.hasProjects = true;
            this.totalProjects = response.data;
            console.log("this.listProjects: "+this.totalProjects);
            this.loadData();
          } else {
            this.hasProjects = false;
            console.log("Error getting data");
          }
        })
        .catch(error => {
          this.hasProjects = false;
          console.log(error);
        });
      //.finally(() => (this.loading = false));
    },
    doMeta(){
      if(this.lang){
        this.hasMeta.title = this.trans[this.lang].title;
        this.hasMeta.description = this.trans[this.lang].description;
      }
    }
  },
  mounted() {
    this.countData();
    this.doMeta();
  },
  computed: {
    ...mapState(["lang"]),
  },
  watch: {
    "$route.params.page": function(page) {
      this.countData();
      console.log("Page:" + page);
    },
    lang: function () {
      this.countData();
      this.doMeta();
    }
  },
  metaInfo() {
    return {
      title: this.$mySite.title,
      titleTemplate: this.hasMeta.title + " | %s",
      htmlAttrs: {
        lang: this.lang
      },
      meta: [
        {
          name: "description",
          content: this.hasMeta.description
        },
        {
          property: "og:title",
          content: this.$mySite.title,
          vmid: "og:title"
        },
        {
          property: "og:description",
          content: this.hasMeta.description,
          vmid: "og:description"
        },
        {
          property: "og:image",
          content: this.$mySite.image,
          vmid: "og:image"
        },
        {
          property: "og:url",
          content: this.$mySite.url,
          vmid: "og:url"
        }
      ]
    };
  } //end meta
};
</script>
